import React, { Component } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const handleWhatsAppOrder = () => {
    const message = encodeURIComponent('Hola! Quiero hacer un pedido.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  const handleWhatsAppEvents = () => {
    const message = encodeURIComponent('Hola! Quiero consultar por eventos y mesas dulces.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  return <section id="inicio" className="relative h-screen w-full overflow-hidden" data-id="element-68">
      <div className="absolute inset-0" data-id="element-69">
        <img src="https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1920&q=80" alt="Panadería artesanal" className="w-full h-full object-cover" data-id="element-70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" data-id="element-71" />
      </div>

      <div className="absolute top-8 right-8 opacity-10" data-id="element-72">
        <svg width="200" height="200" viewBox="0 0 200 200" className="text-primary-yellow" data-id="element-73">
          <path fill="currentColor" d="M100,20 L110,80 L170,80 L120,120 L140,180 L100,140 L60,180 L80,120 L30,80 L90,80 Z" data-id="element-74" />
        </svg>
      </div>

      <div className="relative h-full flex items-center pt-24" data-id="element-75">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-3xl" data-id="element-77">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="inline-block mb-6" data-id="element-78">
              <span className="bg-primary-yellow/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium border border-primary-yellow/30" data-id="element-79">
                Panadería Artesanal · Franquicia
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-80">
              La tradición del buen sabor, ahora en una nueva experiencia
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6
          }} className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed" data-id="element-81">
              Panadería artesanal, mesas dulces, catering y regalos
              empresariales con calidad y excelencia.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8
          }} className="flex flex-col sm:flex-row gap-4" data-id="element-82">
              <button onClick={handleWhatsAppOrder} className="bg-primary-yellow text-secondary-brown px-8 py-4 rounded-full font-semibold text-lg hover:bg-primary-gold transition-all transform hover:scale-105 shadow-lg" data-id="element-83">
                Hacer Pedido
              </button>
              <button onClick={handleWhatsAppEvents} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-secondary-brown transition-all transform hover:scale-105" data-id="element-84">
                Consultar por Eventos
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" data-id="element-85">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="text-white opacity-50" data-id="element-86">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" data-id="element-87">
            <path d="M12 5v14M19 12l-7 7-7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-88" />
          </svg>
        </motion.div>
      </div>
    </section>;
}